module.exports = __webpack_public_path__ + "static/media/matching-score-rank-background.0956214a.png";